import { useEffect } from 'react'

import { offlineStateActions } from '@/state/offline-management/actions'

export const useOffline = (): void => {
  const handleNetworkConenction = (): void => {
    offlineStateActions.setNetworkConnection()
  }

  useEffect(() => {
    window.addEventListener('online', handleNetworkConenction)
    window.addEventListener('offline', handleNetworkConenction)

    return () => {
      window.removeEventListener('offline', () => {})
      window.removeEventListener('online', () => {})
    }
  }, [])
}
